import API, { handleRequest } from '@/api/lib/api'

export const getAllReviews = async restaurant_id =>
  handleRequest(() =>
    API.get(`online-order/settings/restaurant/${restaurant_id}/reviews`)
  )

export const getSingleReview = async item_id =>
  handleRequest(() => API.get(`online-order/settings/reviews/${item_id}`))

export const createReview = async data =>
  handleRequest(() => API.post(`online-order/settings/reviews`, data))

export const updateReview = async (item_id, data) =>
  handleRequest(() => API.put(`online-order/settings/reviews/${item_id}`, data))

export const deleteReview = async id =>
  handleRequest(() => API.delete(`online-order/settings/reviews/${id}`))
